/** Statura brand colour palette */
export const BRAND_COLORS = {
  green: '#96A998',
  deep: '#7B8C7D',
  greenAccessible: '#3E5D4A',
  greenAccessibleHover: '#2F4B3B',
  ink: '#1E293B',
  inkDark: '#0F172A',
  mist: '#F5F6F2',
  fog: '#F7F8F4',
  white: '#FFFFFF',
  slate50: '#F8FAFC',
  slate100: '#F1F5F9',
  slate300: '#CBD5E1',
  slate500: '#64748B',
  slate700: '#334155',
  success: '#22C55E',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#6366F1',
  chartBlue: '#3B82F6',
  chartPurple: '#8B5CF6',
} as const;

export const BRAND_FONTS = {
  serif: "'Merriweather', Georgia, serif",
  sans: "'Space Grotesk', Inter, system-ui, sans-serif",
} as const;
